import { Box } from "@mui/system";
import BLDWebsiteDateFilter from "./BLDWebsiteContent/BLDWebsiteDateFilter";
import BLDWebsiteCategoryFilter from "./BLDWebsiteContent/BLDWebsiteCategoryFilter";
import BLDWebsiteTabs from "./BLDWebsiteContent/BLDWebsiteTabs";
import { useSelector } from "react-redux";
import WebsiteSkeleton from "../../../helpers/WebsiteSkeleton";
import React from "react";

const BLDWebsite = () => {
  const { loadingWebsiteData } = useSelector(
    (state: any) => state.businessLeaderDashBoard,
  );
  const [sortConfig, setSortConfig] = React.useState({
    field: "Date",
    direction: "desc",
  });
  return (
    <>
      <Box sx={{ px: 2 }}>
        <BLDWebsiteDateFilter />
        {loadingWebsiteData ? (
          <WebsiteSkeleton />
        ) : (
          <>
            <BLDWebsiteCategoryFilter
              sortConfig={sortConfig}
              setSortConfig={setSortConfig}
            />
            <BLDWebsiteTabs sortConfig={sortConfig} />
          </>
        )}
      </Box>
    </>
  );
};

export default BLDWebsite;
